import { IOrderItems } from '~api/CartAPI/ICartApiSdk';
import ICartItem from '~domain/entities/CartItem/ICartItem';

export enum DiscountTypes {
    flat = 'flat',
    percentage = 'percentage',
    pro = 'pro',
    dynamic = 'dynamic',
    bogo = 'bogo',
    fullSize = 'fullSize',
    skus = 'skus',
    fullSizeCOS = 'fullSizeCOS',
    offerCartPercentDiscount = 'offerCartPercentDiscount'
}

export const getDiscountType = (item: IOrderItems) => {
    return item?.['offer.benefit.Bogo']
        ? DiscountTypes.bogo
        : item?.['offer.benefit.FixedPrice']
        ? DiscountTypes.dynamic
        : item?.['offer.benefit.FullSizeChoiceOfSkus']
        ? DiscountTypes.fullSizeCOS
        : item?.['offer.benefit.PercentDiscount']
        ? DiscountTypes.percentage
        : item?.['offer.benefit.ProDiscount']
        ? DiscountTypes.pro
        : item?.['offer.benefit.FlatDiscount']
        ? DiscountTypes.flat
        : item?.['offer.benefit.FullSizeSkus']
        ? DiscountTypes.fullSize
        : item?.['offer.benefit.Skus']
        ? DiscountTypes.offerCartPercentDiscount
        : item?.['offer.benefit.OfferCartPercentDiscount']
        ? DiscountTypes.skus
        : null;
};

const itemDiscountTypes = [DiscountTypes.percentage, DiscountTypes.dynamic, DiscountTypes.pro];
const itemOfferSampleTypes = [DiscountTypes.skus, DiscountTypes.bogo];
const fullSizeSampleTypes = [
    DiscountTypes.fullSize,
    DiscountTypes.fullSizeCOS,
    DiscountTypes.percentage,
    DiscountTypes.flat
];
const cartDiscountTypes = [DiscountTypes.offerCartPercentDiscount];

const mapDiscountTypeFlags = (isSample: boolean, discountType?: DiscountTypes | null) => ({
    isOfferItem: !isSample && !!discountType && itemDiscountTypes.includes(discountType),
    isOfferSample: isSample && !!discountType && itemOfferSampleTypes.includes(discountType),
    isFullSizeSample: isSample && !!discountType && fullSizeSampleTypes.includes(discountType),
    hasCartDiscount: !!discountType && cartDiscountTypes.includes(discountType)
});

export const getDiscountsData = (cartItem: ICartItem) => {
    const {
        appliedPriceWithTax: discountedTotalPrice,
        discountPercent: productDiscount,
        product: { isSample, isPricedSample },
        discountType
    } = cartItem;

    const hasFullDiscount = discountedTotalPrice === 0 || productDiscount === 100;
    const hasPartialDiscount = discountedTotalPrice > 0 || productDiscount > 0;
    const hasDiscount = hasFullDiscount || hasPartialDiscount;
    const hasEngraving = cartItem?.hasEngraving || false;

    const {
        isOfferItem = false,
        isOfferSample = false,
        isFullSizeSample = false,
        hasCartDiscount = false
    } = mapDiscountTypeFlags(isSample, discountType);

    const freeSample = hasFullDiscount && isSample;
    const freeItem = hasFullDiscount && !isSample;

    const isDiscountedSample = isFullSizeSample;
    const isDiscountedItem = !freeSample && !freeItem && isOfferItem;
    const isFullDiscountedSample = isPricedSample && hasDiscount && isOfferSample;
    const isCartDiscounted = hasCartDiscount && hasDiscount;

    const showDiscountedTotal =
        isDiscountedItem ||
        isDiscountedSample ||
        isFullDiscountedSample ||
        hasEngraving ||
        isCartDiscounted;

    return { freeItem, freeSample, showDiscountedTotal, isPricedSample };
};
